var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup"
    },
    [
      _c(
        "div",
        { staticClass: "lite_popup_box lite_popup_box_website_restore_select" },
        [
          _c("div", { staticClass: "lite_popup_title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("language.common.restoreNewLocation")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  _vm.show = false
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lite_popup_content" }, [
            _c("div", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading"
                }
              ],
              staticClass: "lite-website-loading"
            }),
            _vm._v(" "),
            _c("div", { staticClass: "website_clone" }, [
              _c("div", { staticClass: "website_from_to" }, [
                _c(
                  "div",
                  { staticClass: "clone_from_to", class: _vm.boxFrom },
                  [
                    _c("div", { staticClass: "clone_head" }, [
                      _c("div", { staticClass: "clone_head_title" }, [
                        _vm._v(_vm._s(_vm.$t("language.common.backups")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "clone_body myscroll" },
                      _vm._l(_vm.websitesFrom, function(website) {
                        return _c(
                          "div",
                          { key: website.id, staticClass: "website_item" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "website_item_box",
                                on: {
                                  click: function($event) {
                                    return _vm.loadWebsiteChilds(
                                      website,
                                      "from"
                                    )
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  staticClass: "website_item_status",
                                  class: {
                                    clone_tree_open: website.isOpen,
                                    clone_tree_close: !website.isOpen,
                                    clone_tree_loading: website.isLoadingChilds
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  class:
                                    "website_item_icon drive-icon-" + "Website"
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "website_item_name" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getDrive(_vm.data.task.fdid).name
                                      )
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            website.isOpen &&
                            website.childs &&
                            website.childs.length > 0
                              ? _c(
                                  "div",
                                  { staticClass: "website_item_childs" },
                                  _vm._l(website.childs, function(node) {
                                    return _c(
                                      "div",
                                      {
                                        key: node.id,
                                        staticClass: "website_item_child",
                                        on: {
                                          click: function($event) {
                                            return _vm.selectNode("from", node)
                                          }
                                        }
                                      },
                                      [
                                        _c("div", {
                                          staticClass: "website_item_status",
                                          class:
                                            _vm.cloneLeftSelect == node.id
                                              ? "clone_radio_select"
                                              : "clone_radio_blank"
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "website_item_icon",
                                          class: "clone_" + node.type
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "website_item_name" },
                                          [_vm._v(_vm._s(node.name))]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e()
                          ]
                        )
                      }),
                      0
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clone_split" }),
                _vm._v(" "),
                _c("div", { staticClass: "clone_center" }, [
                  _c("div", { staticClass: "clone_head" }, [
                    _c("div", { staticClass: "center_left_right" }, [
                      _c("div", { staticClass: "center_left" }, [
                        _c("div", { staticClass: "clone_head_title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.website.sourceServers"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "center_right" }, [
                        _c("div", { staticClass: "clone_head_title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("language.website.targetServers"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "clone_head_icon clone_delete",
                          on: {
                            click: function($event) {
                              return _vm.cleanCloneSelect()
                            }
                          }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clone_body myscroll" }, [
                    _c("div", { staticClass: "center_left_right" }, [
                      _c(
                        "div",
                        { staticClass: "center_left" },
                        _vm._l(_vm.cloneFromData, function(node, index) {
                          return _c(
                            "div",
                            { staticClass: "clone_select_item" },
                            [
                              _c("div", {
                                staticClass: "clone_select_item_icon",
                                class: "clone_" + node.type
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "clone_select_item_name" },
                                [_vm._v(_vm._s(node.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "clone_select_item_delete",
                                  attrs: { title: _vm.getDrive(node.did).name }
                                },
                                [
                                  _c("div", {
                                    staticClass: "clone_delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteSelectItem(index)
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "center_right" },
                        _vm._l(_vm.cloneToData, function(node, index) {
                          return _c(
                            "div",
                            { staticClass: "clone_select_item" },
                            [
                              _c("div", {
                                staticClass: "clone_select_item_icon",
                                class: "clone_" + node.type
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "clone_select_item_name" },
                                [_vm._v(_vm._s(node.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "clone_select_item_delete",
                                  attrs: { title: _vm.getDrive(node.did).name }
                                },
                                [
                                  _c("div", {
                                    staticClass: "clone_delete",
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteSelectItem(index)
                                      }
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clone_split" }),
                _vm._v(" "),
                _c("div", { staticClass: "clone_from_to", class: _vm.boxTo }, [
                  _c("div", { staticClass: "clone_head" }, [
                    _c("div", { staticClass: "clone_head_title" }, [
                      _vm._v(_vm._s(_vm.$t("language.common.restoreTo")))
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "clone_head_icon add_website",
                      on: {
                        click: function($event) {
                          return _vm.readyAddWebsite()
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "clone_body myscroll" },
                    _vm._l(_vm.websites, function(website) {
                      return _c(
                        "div",
                        { key: website.id, staticClass: "website_item" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "website_item_box",
                              on: {
                                click: function($event) {
                                  return _vm.loadWebsiteChilds(website, "to")
                                }
                              }
                            },
                            [
                              _c("div", {
                                staticClass: "website_item_status",
                                class: {
                                  clone_tree_open: website.isOpen2,
                                  clone_tree_close: !website.isOpen2,
                                  clone_tree_loading: website.isLoadingChilds
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "website_item_icon clone_website"
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "website_item_name" }, [
                                _vm._v(_vm._s(website.name))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          website.isOpen2 &&
                          website.childs &&
                          website.childs.length > 0
                            ? _c(
                                "div",
                                { staticClass: "website_item_childs" },
                                _vm._l(website.childs, function(node) {
                                  return _c(
                                    "div",
                                    {
                                      key: node.id,
                                      staticClass: "website_item_child",
                                      on: {
                                        click: function($event) {
                                          return _vm.selectNode("to", node)
                                        }
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "website_item_status",
                                        class:
                                          _vm.cloneRightSelect == node.id
                                            ? "clone_radio_select"
                                            : "clone_radio_blank"
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "website_item_icon",
                                        class: "clone_" + node.type
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "website_item_name" },
                                        [_vm._v(_vm._s(node.name))]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lite_popup_footer" }, [
            _c("button", { on: { click: _vm.selectDone } }, [
              _vm._v(_vm._s(_vm.$t("language.common.ok")))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("liteAddDrive", {
        attrs: { auth: _vm.auth },
        on: {
          submit: function($event) {
            return _vm.addWebsite()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a6a5f70", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6a5f70","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_website_restore_select.vue
// module id = null
// module chunks = 